import React from 'react';

function Hero({ teamHeroInformation }) {
  const { name, logoImageUrl, leagueAndSeason, headerImageUrl } = teamHeroInformation;

  return (
    <div className="site-container site-container--hug-on-mobile">
      <section className="hero-image">
        <a className="hero-image__back" href="/">
          <img
            src="/wp-content/themes/sef-leagues/images/arrow-back.svg"
            alt="Back"
          />
        </a>
        <div
          className="hero-image__container hero-image__container--center mb-0 mb-lg-4"
          style={{
            backgroundImage:
              "url('" + headerImageUrl +"')",
          }}
        >
          <div className="team-hero d-flex align-items-center">
            <img className="team-hero__logo" src={logoImageUrl} alt="" />
            <div className="ms-2 ms-lg-4">
              <h1 className="heading-h4 heading-lg-h2">{name}</h1>
              <div className="heading-h6 heading-lg-h5 text-color-primary-blue">
                {leagueAndSeason}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Hero;
